import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";
import clsx from "clsx";
import firebase from "firebase/app";
import Image from "next/image";
import React, { useRef } from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { CarouselProps } from "@/features/common/components/imageCarousel/type";

export const ImageSlider: React.FC<CarouselProps> = (props) => {
  const sliderRef = useRef<Slider>();

  const { items } = props;

  if (items.length === 0) return null;

  const handleNextSlider = () => {
    firebase.analytics().logEvent(AnalyticsEventEnum.ImageSliderNext);
    sliderRef.current?.slickNext();
  };
  const handlePrevSlider = () => {
    firebase.analytics().logEvent(AnalyticsEventEnum.ImageSliderPrevious);
    sliderRef.current?.slickPrev();
  };

  const isMultiple = items.length > 1;

  const settings: Settings = {
    arrows: false,
    dots: true,
    customPaging(i) {
      return <span className="image-slider-dot-indicator" />;
    },
    dotsClass: "absolute -bottom-7 w-full text-center list-none m-0 p-0",
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  return (
    <div className="relative w-full h-full">
      {isMultiple && (
        <>
          <span
            className="absolute left-4 top-1/2 -translate-y-2/4 text-white shadow-lg touchable z-40"
            onClick={handlePrevSlider}
          >
            <ChevronLeftIcon className="w-5 h-5" />
          </span>
          <span
            className="absolute right-4 top-1/2 -translate-y-2/4 text-white shadow-lg touchable z-40"
            onClick={handleNextSlider}
          >
            <ChevronRightIcon className="w-5 h-5" />
          </span>
        </>
      )}

      <Slider {...settings} className="image-slider" ref={sliderRef}>
        {items &&
          items.map((item, idx) => {
            const { imgSrc, alt, hasAlpha } = item;
            return (
              <div
                onContextMenu={(e) => e.preventDefault()}
                className={clsx(
                  "relative flex h-full justify-center items-center",
                  hasAlpha && "bg-checkerboard-pattern",
                )}
                key={idx}
              >
                <Image
                  src={imgSrc}
                  alt={alt}
                  layout="fill"
                  objectFit="contain"
                  priority={true}
                  unoptimized={props.unoptimized}
                />
              </div>
            );
          })}
      </Slider>
    </div>
  );
};
